import { computed } from 'vue';
import { usePermissions } from './usePermissions';

export function useRepartitionAccess() {
  const { hasRole } = usePermissions();

  const canAccessRepartition = computed(() => {
    const allowedRoles = ['SUPER_ADMIN', 'ADMIN', 'DIRECTEUR', 'CHEF_BUREAU'];
    return hasRole(allowedRoles);
  });

  return {
    canAccessRepartition,
  };
}
